import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { MY_COMMENTS_STREAM } from '../../../streams';
import { AppState } from '../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerStat,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { Props as BoxProps } from './MyCommentsBoxWide';
import { Props as WidgetProps } from './MyComments';
import { PapiModuleMyComments } from '@wix/da-papi-types';

type Props = BoxProps & WidgetProps;
type StateProps = Pick<
  Props,
  | 'items'
  | 'profileOwnerUser'
  | 'totalSent'
  | 'hasMore'
  | 'isEmpty'
  | 'isFetching'
>;
type DispatchProps = Pick<Props, 'fetchMore'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => {
    const items = streamSelectors.getItems<PapiModuleMyComments['results'][0]>(
      state,
      MY_COMMENTS_STREAM
    );
    const totalSent = getProfileOwnerStat(state, 'commentsMade');
    return {
      items,
      totalSent,
      hasMore: streamSelectors.hasMore(state, MY_COMMENTS_STREAM),
      isFetching: streamSelectors.isFetching(state, MY_COMMENTS_STREAM),
      isEmpty: !items.length,
      isOwner: isCurrentUserProfileOwner(state),
      profileOwnerUser: getProfileOwnerUser(state),
    };
  };

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> =
  dispatch => ({
    fetchMore: () => dispatch(withOffset.actions.fetch(MY_COMMENTS_STREAM)),
  });

export default connect(mapStateToProps, mapDispatchToProps);
